export default {
  dataSource: [],
  skuId: []
};
